import { Pipe, PipeTransform } from '@angular/core';
import { LicenseService } from '@shared/services/license.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'isModuleIncludedInLicense'
})
export class IsModuleIncludedInLicensePipe implements PipeTransform {
  public constructor(private licenseService: LicenseService) {}

  transform(moduleId: string): Observable<boolean> {
    return this.licenseService.getLicense().pipe(
      map(license => {
        if (!license?.modules) {
          return false;
        }
        return license.modules.filter(module => module.moduleId === moduleId).length > 0;
      })
    );
  }
}
